(function () {
  if (window.__cartDrawerBound) return;
  window.__cartDrawerBound = true;

  var lastTrigger = null;
  var noteTimer = null;
  var scrollY = 0;

  function getDrawer() {
    return document.getElementById('cart-drawer');
  }

  function ensureDrawer() {
    var drawers = document.querySelectorAll('#cart-drawer');
    if (!drawers.length) return null;
    var drawer = drawers[drawers.length - 1];
    for (var i = 0; i < drawers.length - 1; i++) drawers[i].remove();
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    watchTerms(drawer);
    return drawer;
  }

  function isOpen() {
    var drawer = getDrawer();
    return !!(drawer && drawer.classList.contains('is-open'));
  }

  function setExpanded(open) {
    var triggers = document.querySelectorAll('[data-cart-open]');
    triggers.forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function lockScroll() {
    if (window.YarnMotion) window.YarnMotion.pause();
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + scrollY + 'px';
    document.body.classList.add('cart-drawer-open');
  }

  function unlockScroll() {
    document.body.classList.remove('cart-drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
    if (window.YarnMotion) window.YarnMotion.resume(scrollY);
  }

  function primeNote() {
    var ta = document.querySelector('#cart-drawer [data-cart-note]');
    if (ta) ta.dataset.saved = ta.value;
  }

  function animateShipping() {
    var drawer = getDrawer();
    var track = drawer && drawer.querySelector('.cd-ship__line');
    if (!track) return;
    var next = track.getAttribute('data-p') || '0';
    var prev = drawer.getAttribute('data-ship-p');
    if (prev != null && prev !== '' && prev !== next) {
      track.style.setProperty('--p', prev);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          track.style.setProperty('--p', next);
        });
      });
    }
    drawer.setAttribute('data-ship-p', next);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function imageSrc(src) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (!src) return '';
    if (src.indexOf('width=') !== -1) return src;
    return src + (src.indexOf('?') === -1 ? '?width=200' : '&width=200');
  }

  function getUpsellViewport(block) {
    return block.querySelector('.cd-upsell__viewport');
  }

  function syncUpsellIndex(block) {
    var viewport = getUpsellViewport(block);
    var track = block.querySelector('[data-upsell-track]');
    var cards = track ? track.children.length : 0;
    if (!viewport || !cards) return 0;
    var width = viewport.clientWidth || 1;
    var index = Math.round(viewport.scrollLeft / width);
    if (index < 0) index = 0;
    if (index > cards - 1) index = cards - 1;
    block.setAttribute('data-index', String(index));
    var prev = block.querySelector('[data-upsell-prev]');
    var next = block.querySelector('[data-upsell-next]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= cards - 1;
    return index;
  }

  function setUpsellIndex(block, index) {
    var viewport = getUpsellViewport(block);
    var track = block.querySelector('[data-upsell-track]');
    var cards = track ? track.children.length : 0;
    if (index < 0) index = 0;
    if (index > cards - 1) index = Math.max(cards - 1, 0);
    block.setAttribute('data-index', String(index));
    if (viewport) {
      var width = viewport.clientWidth || 0;
      viewport.scrollTo({ left: index * width, behavior: 'smooth' });
    }
    var prev = block.querySelector('[data-upsell-prev]');
    var next = block.querySelector('[data-upsell-next]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= cards - 1;
  }

  function bindUpsellScroll(block) {
    if (!block || block.getAttribute('data-upsell-scroll-bound') === 'true') return;
    var viewport = getUpsellViewport(block);
    if (!viewport) return;
    block.setAttribute('data-upsell-scroll-bound', 'true');

    viewport.addEventListener('scroll', function () {
      syncUpsellIndex(block);
    }, { passive: true });

    viewport.addEventListener('wheel', function (event) {
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      event.preventDefault();
      viewport.scrollLeft += event.deltaY;
    }, { passive: false });
  }

  function renderUpsell(block, products) {
    var track = block.querySelector('[data-upsell-track]');
    if (!track) return;
    if (!products.length) {
      block.hidden = true;
      track.innerHTML = '';
      return;
    }
    var html = products.map(function (product) {
      var variant = null;
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) {
          variant = variants[i];
          break;
        }
      }
      if (!variant && variants.length) variant = variants[0];
      var variantId = numericId(variant && variant.id);
      var title = escapeHtml(product.title);
      var url = escapeHtml(product.url || '#');
      var img = imageSrc(product.featured_image);
      var meta = [];
      if (variant && variant.title && variant.title !== 'Default Title') meta.push(escapeHtml(variant.title));
      meta.push(escapeHtml(money(variant ? variant.price : product.price)));
      var disabled = !variantId || (variant && variant.available === false);
      return (
        '<article class="cd-upsell__card">' +
          (img ? '<a class="cd-upsell__media" href="' + url + '"><img src="' + escapeHtml(img) + '" alt="' + title + '" width="72" height="72" loading="lazy"></a>' : '') +
          '<div class="cd-upsell__info">' +
            '<a class="cd-upsell__title" href="' + url + '">' + title + '</a>' +
            '<p class="cd-upsell__meta">' + meta.join(' · ') + '</p>' +
          '</div>' +
          '<button type="button" class="cd-plus" data-upsell-add="' + variantId + '" aria-label="Add ' + title + '"' + (disabled ? ' disabled' : '') + '>' +
            '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1.5v11M1.5 7h11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</article>'
      );
    }).join('');
    track.innerHTML = html;
    block.hidden = false;
    bindUpsellScroll(block);
    setUpsellIndex(block, 0);
    syncUpsellIndex(block);
  }

  function loadUpsell() {
    var root = document.getElementById('cart-dropdown');
    if (!root) return;
    var block = root.querySelector('[data-upsell]');
    if (!block) return;
    var pid = block.getAttribute('data-product-id');
    var limit = parseInt(block.getAttribute('data-limit'), 10) || 4;
    var cartIds = (block.getAttribute('data-cart-products') || '').split(',').filter(Boolean);
    var token = pid + ':' + cartIds.join(',');
    if (!pid) {
      block.hidden = true;
      return;
    }
    if (block.getAttribute('data-loaded') === token || block.getAttribute('data-loading') === token) {
      if (block.getAttribute('data-loaded') === token) block.hidden = !block.querySelector('.cd-upsell__card');
      return;
    }
    block.setAttribute('data-loading', token);
    var base = root.getAttribute('data-recommendations-url') || '/recommendations/products';
    var url = base + '.json?product_id=' + encodeURIComponent(pid) + '&limit=' + (limit + cartIds.length + 2);
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!block.isConnected || block.getAttribute('data-loading') !== token) return;
        var products = ((data && data.products) || []).filter(function (product) {
          return cartIds.indexOf(String(product.id)) === -1;
        }).slice(0, limit);
        renderUpsell(block, products);
        block.setAttribute('data-loaded', token);
        block.removeAttribute('data-loading');
      })
      .catch(function (err) {
        console.error(err);
        if (block.isConnected) {
          block.hidden = true;
          block.removeAttribute('data-loading');
        }
      });
  }

  function saveNote(ta) {
    if (!ta || !window.theme || !theme.cart_update_url) return Promise.resolve();
    if (ta.dataset.saved === ta.value) return Promise.resolve();
    var value = ta.value;
    return fetch(theme.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: value })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to save note');
      ta.dataset.saved = value;
      var status = ta.closest('.cd-note') && ta.closest('.cd-note').querySelector('[data-note-status]');
      if (status) {
        status.textContent = 'Saved';
        status.classList.add('is-visible');
        window.setTimeout(function () { status.classList.remove('is-visible'); }, 1400);
      }
    });
  }

  function changeLine(key, quantity) {
    var drawer = getDrawer();
    if (!drawer || !window.theme) return Promise.resolve();
    var ta = drawer.querySelector('[data-cart-note]');
    drawer.classList.add('is-loading');
    var pending = ta ? saveNote(ta) : Promise.resolve();
    return pending.then(function () {
      return fetch(theme.routes_cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update cart');
      return response.json();
    }).then(function () {
      if (typeof CartDrop === 'function') return CartDrop(true);
    }).catch(function (err) {
      console.error(err);
    }).finally(function () {
      var current = getDrawer();
      if (current) current.classList.remove('is-loading');
    });
  }

  function numericId(id) {
    var match = String(id || '').match(/(\d+)\s*$/);
    return match ? match[1] : '';
  }

  function addVariant(id, button) {
    var variantId = numericId(id);
    if (!variantId || !window.theme) return;
    if (button) button.disabled = true;
    var drawer = getDrawer();
    if (drawer) drawer.classList.add('is-loading');
    var body = new FormData();
    body.append('form_type', 'product');
    body.append('utf8', '✓');
    body.append('id', variantId);
    body.append('quantity', '1');
    fetch(theme.routes_cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || (data && data.status && Number(data.status) >= 400)) {
          var message = (data && (data.description || data.message)) || 'Unable to add product';
          if (typeof message !== 'string') message = 'Unable to add product';
          throw new Error(message);
        }
        return data;
      });
    }).then(function () {
      if (typeof CartDrop === 'function') return CartDrop(true);
    }).catch(function (err) {
      console.error(err);
      if (button) {
        button.disabled = false;
        var card = button.closest('.cd-upsell__card');
        var meta = card && card.querySelector('.cd-upsell__meta');
        if (meta) meta.textContent = err.message || 'Could not add this product';
      }
    }).finally(function () {
      var current = getDrawer();
      if (current) current.classList.remove('is-loading');
    });
  }

  function open(trigger) {
    var drawer = ensureDrawer();
    if (!drawer) return;
    if (trigger) lastTrigger = trigger;
    if (!drawer.classList.contains('is-open')) {
      if (window.YarnMotion) window.YarnMotion.prepareDrawer(drawer);
      lockScroll();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (window.YarnMotion) window.YarnMotion.revealDrawer(drawer);
      var closeBtn = drawer.querySelector('.cart-drawer__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
      if (typeof trapFocus === 'function') {
        var panel = drawer.querySelector('.cart-drawer__panel');
        if (panel) trapFocus(panel);
      }
    }
    setExpanded(true);
    watchTerms(drawer);
    loadUpsell();
  }

  function close() {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.classList.remove('motion-entered');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
    setExpanded(false);
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus({ preventScroll: true });
  }

  function toggle(trigger) {
    if (isOpen()) close();
    else open(trigger);
  }

  function stripTerms(drawer) {
    if (!drawer) return;
    var nodes = drawer.querySelectorAll('div, p, label, section, span, form, ul, li');
    var victims = [];
    nodes.forEach(function (el) {
      if (!el.isConnected) return;
      if (el.closest('.cd-note, .cd-items, .cd-ship, .cd-upsell, .cd-footer__row')) return;
      if (el.querySelector('.cd-checkout, .cd-footer__row, .cd-note, .cd-upsell, .cd-ship, .cd-items')) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ');
      if (text.indexOf('I have read and agreed') === -1) return;
      if (text.length > 700) return;
      victims.push(el);
    });
    victims.forEach(function (el) {
      if (!el.isConnected) return;
      var parentListed = false;
      var parent = el.parentElement;
      while (parent && parent !== drawer) {
        if (victims.indexOf(parent) !== -1) {
          parentListed = true;
          break;
        }
        parent = parent.parentElement;
      }
      if (!parentListed) el.remove();
    });
  }

  function watchTerms(drawer) {
    if (!drawer || drawer.getAttribute('data-terms-watch') === 'true') return;
    drawer.setAttribute('data-terms-watch', 'true');
    var observer = new MutationObserver(function () {
      stripTerms(drawer);
    });
    observer.observe(drawer, { childList: true, subtree: true });
    stripTerms(drawer);
  }
  function refresh() {
    var drawer = getDrawer();
    primeNote();
    animateShipping();
    loadUpsell();
    stripTerms(drawer);
    if (window.YarnMotion) window.YarnMotion.refreshDrawer(drawer);
    if (isOpen() && typeof trapFocus === 'function') {
      var panel = drawer && drawer.querySelector('.cart-drawer__panel');
      if (panel) trapFocus(panel);
    }
  }

  document.addEventListener('click', function (ev) {
    var drawer = getDrawer();
    if (!drawer) return;

    var closer = ev.target.closest('[data-cart-drawer-close]');
    if (closer && drawer.contains(closer)) {
      ev.preventDefault();
      close();
      return;
    }

    var noteToggle = ev.target.closest('[data-note-toggle]');
    if (noteToggle && drawer.contains(noteToggle)) {
      var note = noteToggle.closest('.cd-note');
      var expanded = note.classList.toggle('is-open');
      noteToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (expanded) {
        var field = note.querySelector('[data-cart-note]');
        if (field) field.focus();
      }
      return;
    }

    var qtyBtn = ev.target.closest('[data-qty-delta]');
    if (qtyBtn && drawer.contains(qtyBtn)) {
      ev.preventDefault();
      var item = qtyBtn.closest('[data-line-key]');
      if (!item || qtyBtn.disabled) return;
      var current = parseInt(item.getAttribute('data-qty'), 10) || 1;
      var next = current + parseInt(qtyBtn.getAttribute('data-qty-delta'), 10);
      if (next < 0) next = 0;
      var max = item.getAttribute('data-max');
      if (max && next > parseInt(max, 10)) return;
      changeLine(item.getAttribute('data-line-key'), next);
      return;
    }

    var removeBtn = ev.target.closest('[data-remove]');
    if (removeBtn && drawer.contains(removeBtn)) {
      ev.preventDefault();
      var row = removeBtn.closest('[data-line-key]');
      if (row) changeLine(row.getAttribute('data-line-key'), 0);
      return;
    }

    var prev = ev.target.closest('[data-upsell-prev]');
    var nextBtn = ev.target.closest('[data-upsell-next]');
    if ((prev || nextBtn) && drawer.contains(prev || nextBtn)) {
      ev.preventDefault();
      var upsell = (prev || nextBtn).closest('[data-upsell]');
      if (!upsell) return;
      var index = parseInt(upsell.getAttribute('data-index'), 10) || 0;
      setUpsellIndex(upsell, index + (nextBtn ? 1 : -1));
      return;
    }

    var addBtn = ev.target.closest('[data-upsell-add]');
    if (addBtn && drawer.contains(addBtn)) {
      ev.preventDefault();
      addVariant(addBtn.getAttribute('data-upsell-add'), addBtn);
      return;
    }

    var checkout = ev.target.closest('.cd-checkout');
    if (checkout && drawer.contains(checkout) && checkout.getAttribute('href')) {
      var noteField = drawer.querySelector('[data-cart-note]');
      if (noteField && noteField.dataset.saved !== noteField.value) {
        ev.preventDefault();
        var href = checkout.getAttribute('href');
        saveNote(noteField).finally(function () {
          window.location.href = href;
        });
      }
    }
  });

  document.addEventListener('input', function (ev) {
    if (!ev.target.matches('#cart-drawer [data-cart-note]')) return;
    var ta = ev.target;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () { saveNote(ta); }, 450);
  });

  document.addEventListener('focusout', function (ev) {
    if (ev.target.matches && ev.target.matches('#cart-drawer [data-cart-note]')) saveNote(ev.target);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && isOpen()) {
      ev.preventDefault();
      close();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(ensureDrawer, 0);
  });

  window.CartDrawer = {
    open: open,
    close: close,
    toggle: toggle,
    isOpen: isOpen,
    refresh: refresh
  };

  ensureDrawer();
  primeNote();
  animateShipping();
  watchTerms(getDrawer());
})();
